import React, {Component} from 'react'
import CSSModules from 'react-css-modules'
// import {Row, Col} from 'react-flexbox-grid'
import {CopyToClipboard} from 'react-copy-to-clipboard'
import {SlideDown} from 'react-slidedown'
import config from '../../config'
import container from '../../helpers/container'
import {
  ContainerDivs,
  Link,
  LinkIcon,
  // SocialButtons,
  // GetStartedInput,
  AutocompleteSearch
} from '../../components'
import Styles from './Toolkit.css'

function NewlineText(props) {
  return <div>
    { props.text.split('\n\n').map((str, i) => <p key={'nltxt-'+i}>{str}</p>) }
  </div>
}

@CSSModules(Styles, {allowMultiple:true})
export default class Toolkit extends Component {
  constructor(props) {
    super(props)
    this.state = {
      letter401kText: 'Dear Plan Administrator,\n\nI am an employee of [Company Name], and I participate in our company 401(k) plan. I am writing to inquire about weapon free and sustainably invested fund options in the plan.\n\nI am concerned about the financial and moral risks associated with investing my retirement savings in arms manufacturers and military contractors. A growing body of evidence indicates that companies that are socially conscious end up performing better than those that do not. Many large pension funds have already moved to divest from arms manufacturers and military contractors. These facts point to a substantial financial risk of investing in weapon companies.\n\nI believe it is my right to know what companies my retirement savings are invested in. Can you please tell me how I can find out what weapon companies are held in each of the investment options offered in our company plan? Does our retirement plan offer any weapon-free, sustainable investment options?\n\nSustainable investing is no longer just an ethical issue. It is a key factor impacting financial well-being. Guidelines from the Department of Labor state that "environmental, social, and governance factors may have a direct relationship to the economic and financial value of an investment" and can be used when making decisions related to fiduciary duty.\n\nThere is an online tool, weaponfreefunds.org, which analyzes many commonly available mutual funds for investments in weapon companies and identifies funds that are sustainably-invested and weapon free. If none of our current plan options are weapon free, this tool could be used to find suitable mutual funds that could be included in our plan.\n\nThank you in advance for looking into this. I appreciate your time and look forward to hearing from you.\n\nBest,\n\n[Your Name]\n\n[Your contact information (company department, email, phone)]',
      letterAMText: 'Dear Fund Manager,\n\nI am a client of [Company Name]. I am writing to inquire about weapon free and sustainably invested fund options from your company.\n\nI am concerned about the financial and moral risks associated with investing my savings in arms manufacturers and military contractors. A growing body of evidence indicates that companies that are socially conscious end up performing better than those that do not. Many large pension funds have already moved to divest from arms manufacturers and military contractors. These facts point to a substantial financial risk of investing in weapon companies.\n\nCan you please tell me how I can find out what weapon companies are held in each of your company\'s funds? Does your company offer any weapon-free, sustainable investment options?\n\nSustainable investing is not just an ethical issue. It is a key factor impacting financial well-being. Guidelines from the Department of Labor state that "environmental, social, and governance factors may have a direct relationship to the economic and financial value of an investment" and can be used when making decisions related to fiduciary duty.\n\nThank you in advance for looking into this. I appreciate your time and look forward to hearing from you.\n\nBest,\n\n[Your Name]\n\n[Your contact information (email, phone)]',
      copied: false,
      showSection4: null,
      showSection6: null,
      letter401k: true,
    }
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  onCopy = () => {
    this.setState({copied: true});
  };

  render() {
    const title = 'Weapon free action toolkit'
    const description = 'Get your money out of weapon stocks. Use the Weapon Free Funds Action Toolkit to make a change and move your money.'
    const url = config.domain + config.routes.toolkit
    // const message = 'Action toolkit to move your money'
    //
    const iconDove = require( '../../../static/images/toolkit/dove.png' )
    const imgMissiles = require( '../../../static/images/toolkit/missiles.png' )
    const imgDestruction = require( '../../../static/images/toolkit/destruction.png' )
    const iconSearch = require( '../../../static/images/toolkit/search.png' )
    const iconPhone = require( '../../../static/images/toolkit/phone.png' )
    const iconDollar = require( '../../../static/images/toolkit/dollar.png' )
    //
    return (
      <div styleName='page'>
        {container.helmet(title, description, url)}

        <ContainerDivs>
          <header styleName='toolkit-header'>
            <div styleName='toolkit-header-inner'>
              <div styleName='toolkit-header-label-wrap'>
                <div styleName='toolkit-header-label'>
                  Weapon free action toolkit
                </div>
              </div>
              <h1 styleName='toolkit-title'>
                How to make a change and invest in a peaceful future
              </h1>
            </div>
            <img
              src={iconDove}
              role='presentation'
              styleName='toolkit-header-icon'
            />
          </header>
        </ContainerDivs>

        <ContainerDivs>

          { /*
              SECTION 1
          */ }
          <section styleName='toolkit-section-1'>
            <div>
              <h2 styleName='toolkit-section-h2'>
                "[We are facing] a time of <span styleName='span-red'>nuclear danger</span> not seen since the height of the Cold War."
                <span styleName='toolkit-section-h2-cite'>- UN Secretary-General António Guterres</span>
              </h2>
              <p styleName='toolkit-section-p'>
                The largest U.S. mutual fund managers, responsible for funds found across thousands of corporate 401(k) plans, have significant investments in nuclear and other controversial weapons like cluster bombs and white phosphorus. While nations have the right to the legitimate use of weapons for self-defense and national security, having investor-owned arms manufacturers in retirement plans puts people in the position of profiting from this bloodshed.
              </p>
            </div>
            <img
              src={imgMissiles}
              role='presentation'
              styleName='toolkit-section-1-img'
            />
          </section>

          { /*
              SECTION 2
          */ }
          <section styleName='toolkit-section-2'>
            <img
              src={imgDestruction}
              role='presentation'
             styleName='toolkit-section-2-img'
            />
            <div>
              <h2 styleName='toolkit-section-h2'>
                Given a choice, many would not want to profit from companies that manufacture <span styleName='span-red'>weapons of mass destruction.</span>
              </h2>
              <p styleName='toolkit-section-p'>
                Concerns about social impact, human rights, reputation risk, and regulatory risks are just a few of the reasons weapon-free investing has been a common component of sustainable investing for decades. These risks are amplified when companies are involved with nuclear weapons and controversial weapons like cluster munitions, anti-personnel landmines, incendiary weapons, and depleted uranium.
              </p>
            </div>
          </section>

          { /*
              SECTION 3
          */ }
          <section styleName='toolkit-section-3'>
            <h2 styleName='toolkit-section-3-h2'>
              We can help build a more <span styleName='span-pink'>peaceful world</span> by
              shifting our investments away from war and violence.
            </h2>
          </section>

          { /*
              SECTION 4
          */ }
          <section styleName='toolkit-section-4'>
            <div styleName='toolkit-section-steps-123-number'>
              1
            </div>
            <div styleName='toolkit-section-steps-123-content'>
              <h3 styleName='toolkit-section-steps-123-h3'>
                Find your funds
              </h3>
              <p styleName='toolkit-section-steps-123-p'>
                Before finding out what weapons companies might be hidden in your investments, first login to your investment account, and write down the list of funds you are currently invested in. You will use this list in the next step.
              </p>
              <div styleName='toolkit-section-steps-123-buttons'>
                <button
                  onClick={() => {
                    const n = this.state.showSection4 === 1 ? null : 1
                    this.setState({showSection4: n})
                  }}
                >
                  <span styleName={'toolkit-section-steps-123-button ' + (this.state.showSection4 === 1 ? 'active' : '')}>
                    Where are my funds?
                  </span>
                </button>
                <button
                  onClick={() => {
                    const n = this.state.showSection4 === 2 ? null : 2
                    this.setState({showSection4: n})
                  }}
                >
                  <span styleName={'toolkit-section-steps-123-button ' + (this.state.showSection4 === 2 ? 'active' : '')}>
                    Invested in a 401(k)?
                  </span>
                </button>
              </div>
              <SlideDown>
                { this.state.showSection4 && this.state.showSection4 === 1 ?
                    <div styleName='toolkit-section-slidedown-content'>
                      <p styleName='toolkit-section-slidedown-p'>
                        Log in to your 401(k) platform or brokerage account
                        to see which mutual funds you're invested in.
                        If you're having difficulty locating the names of
                        your funds, contact your investment advisor or the
                        customer support team of your investment platform
                        or institution for assistance.
                      </p>
                    </div> : null
                }
              </SlideDown>
              <SlideDown>
                { this.state.showSection4 && this.state.showSection4 === 2 ?
                    <div styleName='toolkit-section-slidedown-content'>
                      <p styleName='toolkit-section-slidedown-p'>
                        Over 100 million employees across the U.S. have over $10 trillion invested in retirement savings, but very few know which companies they are funding with their retirement dollars. Using our <Link to='https://investyourvalues.org/action-center/employees' title='Five steps to a sustainable retirement plan | Invest Your Values'><span styleName='span-link-on-pink'>employee 401(k) toolkit</span></Link>, you will learn how to lower your financial risks from unsustainable investments and maybe even help your co-workers do the same.
                      </p>
                    </div> : null
                }
              </SlideDown>
            </div>
            <img
              src={iconSearch}
              role='presentation'
              styleName='toolkit-section-steps-123-icon'
            />
          </section>

          { /*
              SECTION 5
          */ }
          <section styleName='toolkit-section-5'>
            <div styleName='toolkit-section-steps-123-number'>
              2
            </div>
            <div styleName='toolkit-section-steps-123-content'>
              <h3 styleName='toolkit-section-steps-123-h3'>
                Know what you own
              </h3>
              <p styleName='toolkit-section-steps-123-p'>
                Check to see if your investments are weapon free. Use your investment list from step 1 to find your fund grades. You can search for mutual funds and exchange-traded funds (ETFs) by name, ticker, or asset manager. Our database covers 3,000 stock funds available in the U.S.
              </p>
              <div styleName='toolkit-section-steps-123-search'>
                <AutocompleteSearch />
              </div>
            </div>
            <img
              src={iconPhone}
              role='presentation'
              styleName='toolkit-section-steps-123-icon'
            />
          </section>

          { /*
              SECTION 6
          */ }
          <section styleName='toolkit-section-6'>
            <div styleName='toolkit-section-steps-123-number'>
              3
            </div>
            <div styleName='toolkit-section-steps-123-content'>
              <h3 styleName='toolkit-section-steps-123-h3'>
                Take action
              </h3>
              <p styleName='toolkit-section-steps-123-p'>
                If your investments are exposed to weapons companies, now is the time to sort and compare weapon free alternatives. You can sort by performance and see how funds score on other issues, like climate change. Once you have a found funds that meet your investing circumstances, you can talk to your financial advisor or retirement plan administrator to invest weapon free.
              </p>
              <div styleName='toolkit-section-steps-123-buttons'>
                <Link to={config.routes.clean} title='Top rated funds'>
                  <span styleName='toolkit-section-steps-123-button'>
                    Top rated funds
                  </span>
                </Link>
                <button
                  onClick={() => {
                    const n = this.state.showSection6 === 1 ? null : 1
                    this.setState({
                      showSection6: n,
                      copied: false
                    })
                  }}
                >
                  <span styleName={'toolkit-section-steps-123-button ' + (this.state.showSection6 === 1 ? 'active' : '')}>
                    Send a letter
                  </span>
                </button>
              </div>
              <SlideDown>
                { this.state.showSection6 && this.state.showSection6 === 1 ?
                    <div styleName='toolkit-section-slidedown-content'>
                      <p styleName='toolkit-section-slidedown-p'>
                        Write a letter to your 401(k) plan adminsitrator,
                        or to your fund manager directly. You can copy the
                        text below and update to fit your needs.
                      </p>
                      <div styleName='letter-select-btn-wrap'>
                        <button
                          onClick={() => {
                            this.setState({
                              letter401k: !this.state.letter401k,
                              copied: false
                            })
                          }}
                          styleName='letter-select-btn'
                        >
                          <span>
                            401(k) admin&nbsp;&nbsp;
                          </span>
                          <LinkIcon nospace faclass={'fa-toggle-' + (this.state.letter401k ? 'off' : 'on')}/>
                          <span>
                            &nbsp;&nbsp;Fund manager
                          </span>
                        </button>

                        <CopyToClipboard
                          onCopy={() => { this.setState({copied: true}) }}
                          text={this.state.letter401k ? this.state.letter401kText : this.state.letterAMText}
                        >
                          <button styleName='letter-select-btn'>
                            { this.state.copied ?
                                null :
                                <span><i className='fa fa-files-o'/>&nbsp;&nbsp;&nbsp;</span>
                            }
                            { this.state.copied ?
                                'Copied!' :
                                'Copy to clipboard'
                            }
                          </button>
                        </CopyToClipboard>
                      </div>

                      <div>
                        { this.state.letter401k ?
                            <div>
                              <p>
                                Letter to employer-offered
                                retirement plan manager:
                              </p>
                              <blockquote styleName='letter-blckqt'>
                                <NewlineText text={this.state.letter401kText} />
                              </blockquote>
                            </div> :
                            <div>
                              <p>
                                Letter to mutual fund manager:
                              </p>
                              <blockquote styleName='letter-blckqt'>
                                <NewlineText text={this.state.letterAMText} />
                              </blockquote>
                            </div>
                        }
                      </div>
                    </div> : null
                }
              </SlideDown>
            </div>
            <img
              src={iconDollar}
              role='presentation'
              styleName='toolkit-section-steps-123-icon'
            />
          </section>


        </ContainerDivs>
      </div>
    )
  }
}
